import { IconFacebook } from 'component-library/icons/IconFacebook/IconFacebook'
import { IconTwitter } from 'component-library/icons/IconTwitter/IconTwitter'
import { IconWhatsapp } from 'component-library/icons/IconWhatsapp/IconWhatsapp'
import { IconEmail } from 'component-library/icons/IconEmail/IconEmail'
import { IconReddit } from 'component-library/icons/IconReddit/IconReddit'
import { IconLink } from 'component-library/icons/IconLink/IconLink'
import { ShareOption } from 'common/events/share-events'

export const getIconComponent = (shareOption: ShareOption) => {
    switch (shareOption) {
        case 'facebook':
            return IconFacebook
        case 'twitter':
            return IconTwitter
        case 'whatsapp':
            return IconWhatsapp
        case 'email':
            return IconEmail
        case 'reddit':
            return IconReddit
        case 'clipboard':
            return IconLink
        default:
            return
    }
}
